import { api } from '@forbiz/web-kit'
import type { PublicBannerListResponse } from '@forbiz/contracts'

/** 홈 배너 (BIZ-111). 활성 + 노출기간 안의 배너만 온다(운영자 관리). */
export const bannersApi = {
  list: () => api.get<PublicBannerListResponse>('/api/banners'),
}
